<template>
  <div class="pay-container">
    <van-nav-bar :title="$route.meta.title">
      <template #left>
        <van-icon @click="back" name="arrow-left" color="#46474B" size="20px" />
      </template>
    </van-nav-bar>
    <div class="pay-success text-align-center">
      <img src="@/assets/pay-state/pay-error.png" alt="">
      <p>支付已取消，请重新支付</p>
      <div class="btns flex flex-column">
        <!-- 1v1 不要重新支付 -->
        <button v-if="Number($route.query.caseSourceType) !== 4" @click="toPayAgain">
          重新支付
        </button>
        <!-- <button @click="toQuestionPage"> -->
        <button @click="handleBtn">
          返回
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import { callApp } from "@/libs/bridge";
/**
 * 支付成功 只展示按钮 或者 倒计时操作（任意一个）
 * caseSourceType
  3: 快速咨询（极速咨询）
  4：图文付费资讯（一对一）
  5：案件委托案源
  6：电话咨询案源
 */
import { NavBar,Icon } from 'vant';
import {  speedOrderGoPay } from '@/api/speedOrder'
export default {
  components: {
    'van-icon': Icon,
    'van-nav-bar': NavBar
  },
  mounted(){
    window.physicsBackFn = this.back
  },
  methods: {
    back(){
      this.$router.push(`/pay?orderId=${this.$route.query.orderId}&caseSourceId=${this.$route.query.caseSourceId}`)
    },
    toPayAgain(){
      switch(Number(this.$route.query.caseSourceType)){
      case 4:
      case 3:
      case 5:
      case 6:
      default:
        this.toPayWeixin(this.$route.query.orderId)
        break
      }
    },
    // lawsuitShare.6.0(公共付费极速咨询)直接微信支付
    async toPayWeixin(orderId){
      let hasOrderPayQuery = {
        /* 业务订单id*/
        orderId,
        payType: '2', /* 支付类型[lawsuitShare:支付宝,2:微信]*/
      }
      let resp = await speedOrderGoPay(hasOrderPayQuery)
      window.location.href = JSON.parse(resp.data.payResultMsg).h5_url
    },
    // 失败返回
    handleBtn(){
      switch(Number(this.$route.query.caseSourceType)){
      case 4:
      case 5:
      case 3:
      case 6:
      default:
        this.$router.push(`/pay?orderId=${this.$route.query.orderId}&caseSourceId=${this.$route.query.caseSourceId}`)
        break
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pay-container{
  min-height: 100vh;
  background: white;
}
.pay-success{
  font-size: 0;
  p{
    padding: 29px 0 48px;
    font-size: 16px;
    color: #333333;
  }
  img{
    padding-top: 48px;
    width: 121px;
    height: 120px;
    // width: 105px;
    // height: 115px;
  }
  .btns{
    align-items: center;
    button{
      width: 142px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #FFA700;
      font-size: 15px;
      font-weight: 600;
      background: #FFA700;
      color: #fff;
    }
    button{
      &:nth-child(2){
        // color: #FFA700;
        background: white;
        margin-top: 15px;
        border-radius: 20px;
        border: 1px solid #EEEEEE;
        color: #333333;
      }
    }
  }
}
</style>
